import React from "react";
import Table from "../Table";
import {column} from "../../lib/column";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Localize from "../Localize/Localize";
import LocalizeKeys from "../Localize/LocalizeKeys";
class Editor extends React.Component {

  componentDidMount() {
    const columns = this.props.columns.filter(x =>
        x["key"] !== "edit" && x["key"] !== "delete" && x["key"] !== "view"
    );

    if (this.props.isEditable) {
      columns.push(
          column(this, "edit", { showAs: "button", linkTo: this.edit.bind(this) })
      );
    }

    if (this.props.isDeletable) {
      columns.push(
          column(this, "delete", { showAs: "button", linkTo: this.delete.bind(this) })
      );
    }

    if (this.props.isViewable) {
      columns.push(
          column(this, "view", { showAs: "button", linkTo: this.view.bind(this) })
      );
    }

    this.state.columns = columns;

    this.state.ignore = this.props.ignore || [];
    if (this.props.isEditable) this.state.ignore.push("edit");
    if (this.props.isDeletable) this.state.ignore.push("delete");
    if (this.props.isViewable) this.state.ignore.push("view");

    const contents = [];
    this.props.data.map(x => {
      if (this.props.isEditable) x["edit"] = Localize.translate(LocalizeKeys.TABLE_EDIT);
      if (this.props.isDeletable) x["delete"] = Localize.translate(LocalizeKeys.TABLE_DELETE);
      if (this.props.isViewable) x["view"] = Localize.translate(LocalizeKeys.TABLE_VIEW);
      contents.push(x);
    });

    const empty_content = {};
    this.state.columns.forEach(x => {
      empty_content[x["key"]] = "";
    });

    this.setState({ contents: contents, content: null, empty_content: empty_content, mode: "table" });
  }


  edit(pollo, row) {
    // alert(JSON.stringify(row));
    this.setState( { new: false, mode: "single", content: row } )
  }

  view(pollo, row) {
    // alert(JSON.stringify(row));
    
    if (this.props.onView)
    {
      this.props.onView(row);
    }
    else
    {
      this.setState( { new: false, mode: "view", content: row } )
    }
  }
  
  delete(pollo, row) {
    // alert(JSON.stringify(row));
    if (window.confirm("Are you sure to delete " + JSON.stringify(row))) {
      this.props.onDelete(row)
    }
    else {
      window.alert("That's fine, nothing has happened!")
    }
  }

  change(event) {
    // this.props.callback(event.target.value);
    this.setState( {content: {...this.state.content, [event.target.id]: event.target.value} } );
  }

  state = {
    contents: null,
    content: null,
    empty_content: null,
    mode: "table",
  }

  render() {

    const tokenStyle = {
      wordWrap: "break-word",
      backgroundColor: "#f8f8f8",
      padding: "20px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      margin: "10px auto",
      textAlign: "left",
      fontFamily: "monospace",
      display: "inline-block",
      boxSizing: "border-box",
    };

    const redButtonStyle = {
      padding: "6px",
      backgroundColor: "#e74c3c",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "1rem",
    };
    
    return (
      this.props.data && <div style={tokenStyle}>
        
        {/*Table*/}
        {
          this.state.mode === "table" && this.state.contents && <div>
            <Table
              data={this.state.contents}
              columns={this.state.columns}
              hideOptions
              hideCsv
              hideTop
            />
            {/*<button onClick={ () => this.setState( { new: false, mode: "single", content: this.state.empty_content } ) }>New!</button>*/}
          </div>
        }

        {/*Editor*/}
        {
          this.state.mode === "single" && this.state.content && <div>
            {
              Object.keys(this.state.content).map(x => {
                const id = x;
                if (!this.state.ignore.includes(id)) {
                  return <p key={id}>{id} <input onChange={this.change.bind(this)} value={this.state.content[id]} size={128} id={id} /></p>
                }
                else {
                  return null;
                }
              })
            }
            <button style={{backgroundColor: "red"}} onClick={ () => this.setState( { new: false, mode: "table" } ) }>Back!</button>
            <button style={{backgroundColor: "#00ff00"}} type={"submit"} onClick={() => this.props.onUpdate(this.state.content)}>Submit!</button>
          </div>
        }

        {/*View*/}
        {
            this.state.mode === "view" && this.state.content && <div>
              <button
                  style={{
                    ...redButtonStyle,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1px",
                  }}
                  onClick={() => this.setState({ new: false, mode: "table" })}
              >
                <ArrowBack />
                Back
              </button>
          
              {
                this.props.customView !== null ? (
                typeof this.props.customView === "string" ? (
                      <div style={{ whiteSpace: "pre-line", fontSize: "1.1rem", fontFamily: "monospace",}}>
                        {this.props.customView.replace(/\$(\w+)/g, (_, key) => this.state.content[key] || `[$${key}]`)}
                      </div>
                  ) : (
                      this.props.customView
                  )) :
                    Object.keys(this.state.content).map(x => {
                  const id = x;
                  if (!this.state.ignore.includes(id)) {
                    return (
                        <div key={id} style={{ marginBottom: '10px' }}>
                          <p style={{ fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '5px' }}>
                            {id}
                          </p>
                          <p style={{ margin: 0 }}>
                            {this.state.content[id]}
                          </p>
                        </div>
                    );
                  } else {
                    return null;
                  }
                })
              }
            </div>
        }

      </div>
    );
  }

}

export default Editor;
